var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMapMarkerBusiness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 16.786C33 8.07 25.833 1 17 1S1 8.071 1 16.786c0 3.357 1.086 6.5 2.896 9.071L17 43l13.104-17.143C31.914 23.286 33 20.143 33 16.786",
    stroke: "#1A396F",
    fill: "#346DCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h20v20H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.333 12.679V9.222H9v15.556h16.667V12.679h-8.334zm-5 10.37h-1.666v-1.728h1.666v1.728zm0-3.456h-1.666v-1.729h1.666v1.729zm0-3.457h-1.666v-1.729h1.666v1.729zm0-3.457h-1.666v-1.728h1.666v1.728zm3.334 10.37H14v-1.728h1.667v1.728zm0-3.456H14v-1.729h1.667v1.729zm0-3.457H14v-1.729h1.667v1.729zm0-3.457H14v-1.728h1.667v1.728zM24 23.049h-6.667v-1.728H19v-1.728h-1.667v-1.729H19v-1.728h-1.667v-1.729H24v8.642zm-1.667-6.913h-1.666v1.728h1.666v-1.728zm0 3.457h-1.666v1.728h1.666v-1.728z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMapMarkerBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-map-marker-business.2f1b9b541dde413f1ebc00ad568bb1e2.svg";